export const branchNoText = (name, brchNo)=>{
  let modName = name || ""
  let modBrchNo = brchNo || 0
  const lang = modName.charCodeAt(0)< 256?"EN":"TH"
  
  
  if(+modBrchNo=== 0){
    return lang==="EN"?"(HEAD OFFICE)":"(สำนักงานใหญ่)"
  } else {
    const brchNoTxt  = modBrchNo.toString().padStart(5, '0')
    return lang==="EN"?`(BRANCH\xa0${brchNoTxt})`:`(สาขาที่\xa0${brchNoTxt})`
  }
}